import { ICopyable } from '../controls/common/icopyable';
import { IApplication } from './interfaces/application.interface';
import { IDisplayableItem } from './interfaces/displayable-item.interface';

export class Application implements ICopyable<Application>, IDisplayableItem {
    public id: string = null;
    public roles: number[] = null;
    public displayName: string = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): Application {
        const instance = new Application();
        instance.id = this.id;
        instance.roles = [...this.roles];
        instance.displayName = this.displayName;

        return instance;
    }

    public static createFormCopy(user: Application): IApplication {
        const instance = new Application();
        instance.id = user.id;
        instance.roles = [...user.roles];
        instance.displayName = user.displayName;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.roles = [...other.roles];
        this.displayName = other.displayName;
    }

    public getDisplayName() {
        return `${this.displayName}`;
    }
}
